Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedUserView extends Backbone.View
  template: JST["backbone/templates/monitoring/filters/user/applied_user"]
  className: 'user'

  unmodifiableByModerators: false

  events:
    "click div.user_being_applied a.remove" : "removeUser"
    "click div.influencer a.remove" : "removeInfluencers"
    "click div.influencer_list a.remove" : "removeInfluencerList"

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery

  destroy: () ->
    this.remove()
    return false

  render: ->
    @$el.html(@template(searchQuery: @searchQuery))
    @allowClearFilter() unless @unmodifiableByModerators
    return this

  removeUser: (event) =>
    user = $(event.target).parent().find('.user').text()
    @searchQuery.removeUser(user)
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  removeInfluencers: (event) =>
    @searchQuery.setFilterByKlout(false);
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  removeInfluencerList: (event) =>
    @searchQuery.setFilterByInfluencerList(false);
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  allowClearFilter: ->
    @$el.find('a.remove, a.remove-filters').attr('style', 'display: inline')